import { makeStyles } from 'tss-react/mui';

const useStylesExpansionGroup: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  expansionGroupTableGroup: {
    margin: '0 !important',
    boxShadow: 'none !important',
  },
  expansionGroupHeader: {
    minHeight: '15px !important',
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.common.white} !important`,
    borderBottom: `1px solid ${theme.palette.common.white} !important`,
    paddingBottom: '0 !important',
    paddingTop: '0 !important',
    '& svg': {
      color: `${theme.palette.common.white} !important`,
    },
  },
  expansionGroupHeaderFixed: {
    cursor: 'default !important',
  },
  expansionGroupHeaderSecondary: {
    backgroundColor: `${theme.palette.primary.dark} !important`,
  },
  expansionGroupExpanded: {
    marginTop: '0 !important',
    marginBottom: '0 !important',
  },
  expansionGroupExpandedOffset: {
    marginBottom: '20px !important',
  },
  expansionGroupHeaderExpandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    color: theme.palette.common.white,
    padding: 0,
    margin: 0,
  },
  expansionGroupHeaderExpandIconFixed: {
    display: 'none !important',
  },
  expansionGroupOffset: {
    marginBottom: '20px !important',
  },
  expansionGroupFullWidth: {
    width: '100%',
  },
  expansionGroupContent: {
    margin: '5px 0 5px 0 !important',
    padding: 0,
    minHeight: 15,
  },
  expansionGroupContentFixed: {
    cursor: 'default',
  },
  expansionGroupHeaderExpanded: {
    minHeight: '15px !important',
  },
  expansionGroupHeaderFocusVisible: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  expansionGroupDetails: {
    overflowX: 'auto !important',
    overflowY: 'auto !important',
    whiteSpace: 'nowrap',
    padding: '0 !important',
  },
  expansionGroupDetailsTableGroup: {
    overflowX: 'visible !important',
    overflowY: 'visible !important',
  },
  expansionGroupDetailsScrollable: {
    overflowX: 'scroll !important',
  },
}));

export default useStylesExpansionGroup;
